<template>
  <div id="login-form">
    <div class="login-form-title">设置您的账号及密码</div>
    <van-cell-group>
      <van-field
        v-model="account1" label="账号"
        clearable
        required
        placeholder="账号只能使用数字或字母,长度不超过12位"
        @blur="checkAccount1"
        :error-message="errMsg.account1"
      />
      <van-field
        v-model="password" label="密码"
        clearable
        required
        type="password"
        placeholder="密码长度至少6位"
        @blur="checkPassword"
        :error-message="errMsg.password"
      />
      <van-field
        v-model="confirmPwd" label="确认密码"
        clearable
        required
        type="password"
        placeholder="请输入确认密码"
        @blur="checkConfirmPwd"
        :error-message="errMsg.confirmPwd"
      />
    </van-cell-group>
    <van-field 
      v-model="companyName"
      label="单位名称"
      clearable
      required
      placeholder="请输入单位名称" 
      @blur="checkCompanyName"
      :error-message="errMsg.companyName"  />
    

    <van-field
      clearable
      required
      name="picker"
      label="所属行业"
      :value="industryVal"
      placeholder="请选择行业"
      @click="showPickIndustry = true"
      :error-message="errMsg.industryVal"
    />
    <!-- <van-divider :style="{padding: '0 10px', margin: '0 0px' }" /> -->
    <!-- 行业pop -->
    <van-popup v-model="showPickIndustry" position="bottom">
      <van-picker
        show-toolbar
        :columns="industryColumns"
        @confirm="onConfirm"
        @cancel="showPickIndustry = false"
      />
    </van-popup>
    <van-field
      v-model="regMoblie"
      label="联系电话"
      clearable
      required
      disabled
      placeholder="请输入联系电话" />
    <!-- 地区 -->
    <!-- <van-field readonly clickable name="picker" label="所在地域"
      :value="areaVal"
      required
      placeholder="请选择地区"
      :error-message="errMsg.areaVal"
      @click="showPickArea = true"
    />
    <van-popup v-model="showPickArea" position="bottom">
      <van-area title="城市切换" :area-list="areaList" 
        @confirm="onConfirmArea"
        @cancel="showPickArea = false" />
    </van-popup> -->
    <div class="tip" style="margin-top: 20px">
      <van-notice-bar wrapable :scrollable="false">
        <h4>特别提示：</h4>
        <p v-if="isWX == '1'">
              请及时关注微信公众号“众智云擎税法检索”, 即时精准获取税法文件智能推送。
        </p>
        <p v-else>
          请及时关注微信公众号“众智云擎税法检索”, 点击“云擎中心”按钮进入“文件提醒”, 即时精准获取税法文件智能推送。
        </p>
      </van-notice-bar>
    </div>
    <div style="margin-top: 30px">
      <van-button
        v-if="toLabel == 2"
        block
        type="info"
        style="border-radius: 30px"
        @click="submitInfo"
        >提交</van-button
      >
      <van-button
        v-if="toLabel == 1"
        block
        type="info"
        style="border-radius: 30px"
        @click="wxRegLogin"
        >提交</van-button
      >
    </div>
  </div>
</template>

<script>
import { commonDialog,commonNotify } from "@/utils/lib/toast.js";
import { searchToObj, getUrlParam } from "@/utils/lib/searchtoobj.js";
export default {
  props: ["regMoblie", "regCode", "toLabel", "agentCode", "matching"],
  data() {
    return {
      account1: "", // 注册账号
      password: "", // 密码
      confirmPwd: "", // 确认密码
      errMsg: {
        account1: "", // 注册账号
        password: "", // 密码
        confirmPwd: "", // 确认密码
        companyName: "",
        industryVal: "",
        areaVal: ""
      },
      pattern: /^1[3456789]\d{9}$/, // 手机号码验证
      accPattern: /^[0-9a-zA-Z]{3,12}$/, // 验证账号格式 账号只能使用数字、字母、下划线,不超过12位
      companyName: '',
      industryVal: '',
      industryCode: '',
      showPickIndustry: false, // 是否展示筛选行业picker
      industryColumns: [],
      areaVal: '', // 选中地区显示值
      showPickArea: false, // 是否展示筛选地区picker
      areaList: [],
      areaProCode: '000000', // 当前选中省级编码
      areaCityCode: '000000', // 当前选中市级编码
      isCheckAccount: true,
      isWX: Number(localStorage.getItem("WX_VERSION"))
    };
  },
  computed: {
    userGuid() {
      return this.$store.state.user.userGuid;
    }
  },
  created () {
    this.getIndustryList()
    this.getProvinceAndCity()
  },
  methods: {
    // 确认选择行业
    onConfirm(value) {
      this.industryVal = value.text;
      this.industryCode = value.industryid
      this.showPickIndustry = false;
    },
    // 获取行业优惠信息
    getIndustryList () {
      this.$http
        .reqIndustryList()
        .then((res) => {
          this.industryColumns = res.item.unshift({
            industryid: "000000",
            title: "所有行业"
          })
          this.industryColumns = res.item.map(it => {
            return {
              text: it.title,
              ...it
            }
          })
        })
        .catch((err) => {
          this.$dialog.alert({
            message: err.message,
          })
        });
    },
    // 确认选择地区
    onConfirmArea(values) {
      this.areaVal = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join('/');
      console.log(values)
      if(values[0].code == '110000' || values[0].code == '120000' || values[0].code == '310000' || values[0].code == '500000' ) {
        this.areaProCode = values[0].code
        this.areaCityCode = values[2].code
      } else {
        this.areaProCode = values[0].code
        this.areaCityCode = values[1].code
      }
      
      this.showPickArea = false;
    },
    // 提交注册信息
    async submitInfo () {
      await this.checkAccount1()
      if (!this.isCheckAccount) {
        return false
      }
      if (!this.checkPassword()) {
        return false
      }
      if (!this.checkConfirmPwd()) {
        return false
      }
      if (!this.checkCompanyName()) {
        return false
      }
      if (!this.industryVal) {
        this.errMsg.industryVal = "请选择所属行业";
        return false;
      } else {
        this.errMsg.industryVal = "";
      }
      this.$http.reqPhoneReg({
        userid: this.account1,
        mobilenum: this.regMoblie,
        tempuserguid: this.userGuid,
        password: this.password,
        smscode: this.regCode,
        workunit: this.companyName,
        companytel: this.regMoblie,
        province: this.areaProCode,
        city: this.areaCityCode,
        industry: this.industryCode,
        login: true
      }).then((res) => {
        if (res.rtncode === 1) {
          if (res.rltcode === 1) {
            commonDialog("账号注册成功", this)
            this.$emit('closeLoginForm')
            
            this.$store.commit("user/setUserGuid", res.userguid)
            this.$store.commit("user/setToken", res.token)

            this.$http.reqCreateDefault().then((res) => {
              if (res.rltcode === 1) {
                if (res.rltcode === 1) {
                }
              }
            })
            //注册成功增加一次注册引导教学
            console.log('add guidetimes 1')
            this.$store.state.user.guidetimes++
          } else {
            commonDialog(res.rltdesc, this)
          }
        } else { 
          commonDialog(res.rtndesc, this)
        }
      })
    },
    // 微信注册登录
    async wxRegLogin () {
      let shareUserguid = localStorage.getItem("shareUserguid")
      let obj = searchToObj(location.search)
      await this.checkAccount1()
      if (!this.isCheckAccount) {
        return false
      }
      if (!this.checkPassword()) {
        return false
      }
      if (!this.checkConfirmPwd()) {
        return false
      }
      if (!this.checkCompanyName()) {
        return false
      }
      if (!this.industryVal) {
        this.errMsg.industryVal = "请选择所属行业";
        return false;
      } else {
        this.errMsg.industryVal = "";
      }
      //let obj = searchToObj(location.search)
      this.$http.reqWxReg({
        code: obj.code,
        state: obj.state,
        userid: this.account1,
        password: this.password,
        tempuserguid: this.userGuid,
        fromagent: this.agentCode,
        fromdesc: '',
        companyname: this.companyName,
        companytel: this.regMoblie,
        industry: this.industryCode,
        username: '',
        mobile: this.regMoblie,
        smscode: this.regCode,
        province: this.areaProCode,
        city: this.areaCityCode,
        shareguid: shareUserguid,
        spreadguid: sessionStorage.getItem("spreadCode")
      }).then((res) => {
        if (res.rtncode === 1) {
          if (res.rltcode === 1) {
            window.localStorage.removeItem("shareUserguid")
            //commonDialog("微信账号注册成功", this);
            commonNotify("微信账号注册成功!", this);
            this.bus.$emit("saveTokenHandle", res, 1);
            this.$emit('closeLoginForm')
            if(this.agentCode) {
              this.$router.push(
                `/onlineMall?agentcode=${this.agentCode}`
              )
            } else if(localStorage.getItem('matching')) {
              this.$router.push("/policyMate");
              window.localStorage.removeItem("matching")
            } else {
              this.$router.push("/newFiles");
            }
            this.$http.reqCreateDefault().then((res) => {
              if (res.rltcode === 1) {
                if (res.rltcode === 1) {
                  //
                }
              }
            })
            //微信注册成功增加一次注册引导教学
            console.log('add guidetimes 1')
            this.$store.state.user.guidetimes++
          } else {
            commonDialog(res.rltdesc, this)
          }
        } else {
          commonDialog(res.rtndesc, this)
        }
      })
    },
    // 检查账号
    checkAccount1() {
      this.isCheckAccount = true
      if (!this.account1) {
        this.errMsg.account1 = "请输入账号";
        this.isCheckAccount = false
        return false;
      } 
      if (this.account1.length > 12) {
        this.errMsg.account1 = "账号长度不超过12位";
        this.isCheckAccount = false
        return false;
      }
      if (this.account1.length < 3) {
        this.errMsg.account1 = "账号长度不小于3位";
        this.isCheckAccount = false
        return false;
      } 
      if (
        this.account1.length <= 12 &&
        !this.accPattern.test(this.account1)
      ) {
        this.errMsg.account1 = "账号只能使用数字或字母";
        this.isCheckAccount = false
        return false;
      }
      this.$http.reqCheckUserId("", this.account1).then((resp) => {
        if (
          resp.rtncode === 1 &&
          resp.rltcode === 1 &&
          resp.enabled === true
        ) {
          this.errMsg.account1 = "";
          this.isCheckAccount = true
        } else if (
          resp.rtncode === 1 &&
          resp.rltcode === -1 &&
          resp.enabled === false
        ) {
          this.errMsg.account1 = "该账号已被注册，请重新设置";
          this.isCheckAccount = false
        }
      })
    },
    // 密码
    checkPassword() {
      if (!this.password) {
        this.errMsg.password = "请输入密码";
        return false;
      } else if (this.password.length < 6) {
        this.errMsg.password = "密码长度至少6位";
        return false;
      } else if (this.password.length > 12) {
        this.errMsg.password = "密码长度不得大于12位";
        return false;
      } else if (this.confirmPwd && this.password !== this.confirmPwd) {
        this.errMsg.confirmPwd = "两次密码不一致";
        return false;
      } else {
        this.errMsg.password = "";
        return true;
      }
    },
    // 确认密码
    checkConfirmPwd() {
      if (!this.confirmPwd) {
        this.errMsg.confirmPwd = "请输入确认密码";
        return false;
      } else if (this.password !== this.confirmPwd) {
        this.errMsg.confirmPwd = "两次密码不一致";
        return false;
      } else {
        this.errMsg.confirmPwd = "";
        return true;
      }
    },
    // 检查单位名称
    checkCompanyName () {
      if (!this.companyName) {
        this.errMsg.companyName = "请输入单位名称";
        return false;
      } else {
        this.errMsg.companyName = "";
        return true;
      }
    },
    // 获取分类
    getProvinceAndCity () {
      this.$http
        .reqGetProvinceAndCity()
        .then((res) => {
          let provinceAndCitylists = {
            province_list: {},
            city_list: {},
            county_list: {}
          }
          res.datas.map((item) => {
            provinceAndCitylists.province_list[item.id] = item.label
            // 直辖市
            if (['110000', '120000', '310000', '500000'].includes(item.id)) {
              provinceAndCitylists.city_list[(parseInt(item.id) + 100).toString()] = item.label
              if (item.children && item.children.length > 0) {
                item.children.forEach((it) => {
                  provinceAndCitylists.county_list[it.id] = it.label
                })
              }
            } else {
              if (item.children && item.children.length > 0) {
                item.children.forEach((it) => {
                  provinceAndCitylists.city_list[it.id] = it.label
                })
              }
            }
          })
          this.areaList = provinceAndCitylists
        })
        .catch((err) => {
          this.$dialog.alert({
            message: err.message,
          })
        });
    }
  }
};
</script>

<style lang="less" scoped>
#login-form {
  font-size: 14px;
  padding: 0 10px 10px 10px;
  /deep/.van-cell {
    border: 1px solid #ededef;
    border-radius: 6px;
    margin-bottom: 10px;
    min-height: 30px;
  }
  .van-popup--bottom.van-popup--round {
    border-radius: 10px 10px 0 0;
  }
  /deep/.van-cell:not(:last-child)::after {
    border-bottom: none;
  }
  /deep/.van-field__control {
    font-size: 12px;
  }
  .login-form-title {
    font-weight: 600;
    text-align: center;
    margin: 5px 0 20px 0;
    font-size: 18px;
    color: #00a7fa;
  }
}
</style>
